<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>

<mat-toolbar class="main-toolbar cf-flex-row cf-justify-content-end" color="primary">
  <div class="left-side">
    <span class="title" data-test="ProjectList">{{ 'UI.ProjectList.Text.ProjectList' | translate }}</span>
  </div>
  <button *ngIf="canAddProject$ | async" data-test="AddProjectButton" mat-button (click)="addProject()">
    {{ 'UI.ProjectList.Action.AddProject' | translate }}
  </button>
  <div *ngIf="isAdmin$ | async">
    <input type="file" style="display: none" accept=".xml" (change)="importFromXml(fileInput)" #fileInput />
    <button mat-button clear (click)="fileInput.click()">Import xml</button>
  </div>
</mat-toolbar>

<div class="main-content">
  <div *ngIf="loading$ | async" class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
  <div *ngIf="(loading$ | async) === false" class="project-list-container">
    <div *ngIf="projectEntityList$ | async" class="cf-flex-column">
      <app-project-list-filter></app-project-list-filter>
      <div>
        <app-project-list-table [entities]="projectEntityList$ | async"></app-project-list-table>
        <app-project-list-paging></app-project-list-paging>
      </div>
    </div>
  </div>
</div>
